import * as React from 'react';
import { CMS_THEME } from 'src/common/enums';
import RichText from '../rich_text/RichText';

interface ParagraphProps extends Paragraph {
  text: {
    value: string;
    format: TextFormat;
    processed: string;
  };
}

interface ParagraphTextProps {
  node: ParagraphProps;
  props: { cmsTheme?: CMS_THEME };
}

const ParagraphText: React.FC<ParagraphTextProps> = function ({ node, props }) {
  const classes = node.behavior_settings?.decoupled_styles?.classes || [];
  const text =
    // eslint-disable-next-line no-nested-ternary
    node.text?.format === 'plain_text'
      ? node.text?.value
      : node.text?.processed
        ? node.text.processed
        : '';
  return (
    <RichText cmsTheme={props.cmsTheme} className={classes && classes.join(' ')} body={text} />
  );
};

export default ParagraphText;
